import { Button, Modal } from 'semantic-ui-react';

function DeleteModal({
  deleteHandler,
  closeHandler,
  isModalOpen,
  header,
  text,
  isLoading,
}: {
  deleteHandler: () => void;
  closeHandler: () => void;
  isModalOpen: boolean;
  isLoading?: boolean;
  header?: string;
  text?: string;
}) {
  return (
    <>
      {isModalOpen && (
        <Modal closeOnDocumentClick={false} onClose={closeHandler} open={true}>
          <Modal.Header>{header ? header : 'Delete Confirmation'}</Modal.Header>
          <Modal.Content>
            <div id="delete-modal">
              <p>{text}</p>
              <Button.Group>
                <Button disabled={isLoading} onClick={closeHandler}>
                  Cancel
                </Button>
                <Button.Or />
                <Button
                  loading={isLoading}
                  disabled={isLoading}
                  positive
                  onClick={deleteHandler}
                >
                  Delete
                </Button>
              </Button.Group>
            </div>
          </Modal.Content>
        </Modal>
      )}
    </>
  );
}

export default DeleteModal;
